import React from 'react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
export function Story() {
  return <section className="w-full bg-white px-5 py-16 sm:py-24" aria-labelledby="story" data-id="element-287" data-mp="1iaucgzncru2w">
      <div className="mx-auto max-w-2xl" data-id="element-288" data-mp="1n4gg62bjgnmk">
        <SectionHeading eyebrow="A new way to organize pediatric praxis cases" title="You Don’t Always Need More Theory. Sometimes, You Need a Clearer Way to Organize What You’re Observing." data-id="element-289" data-mp="1n5htkdg11m7g" />
        <div className="mt-10 space-y-5 text-[1.07rem] leading-relaxed text-ink/80" data-id="element-290" data-mp="zdazjkxrxrb7">
          <p data-id="element-291" data-mp="14cnoqcc4bagy">If you’re a Pediatric Occupational Therapist, you probably know the feeling.</p>
          <p data-id="element-292" data-mp="14f0br3wqgb0v">
            You observe a child struggling to imitate a movement, organize a new motor sequence, or complete an unfamiliar
            activity. You notice that the child performs differently depending on the task, the environment, the
            instructions, or the level of support provided.
          </p>
          <p data-id="element-293" data-mp="192lb4rtilnxm">
            You collect information during therapy sessions, review family reports, and try to connect everything you have
            observed. But when you sit down to organize the case, you may find yourself asking:
          </p>
          <blockquote className="my-8 border-l-4 border-cta bg-paper py-5 pl-5 pr-4 font-heading text-[1.4rem] font-medium leading-snug text-ink sm:text-2xl" data-id="element-294" data-mp="z22ip8nvwz43">
            “How do I distinguish the motor difficulties I’m actually observing from the explanations I’m considering?”
          </blockquote>
          <p data-id="element-295" data-mp="lb65oq6fyqi5">
            That’s exactly why I created the <strong className="text-ink" data-id="element-296" data-mp="gcut47ori1w8">Praxis & Motor Planning Clinical Pathway™</strong>.
          </p>
          <p data-id="element-297" data-mp="bet99kjihyjp">
            A practical educational resource that helps you organize motor planning observations, identify relevant task
            demands, recognize missing information, and approach praxis-related questions through a more structured
            reasoning process.
          </p>
          <p data-id="element-298" data-mp="3ouvi6hqwed7i">
            Instead of another massive collection of disconnected theory, it’s a visual system you can return to whenever a
            pediatric motor planning case feels difficult to organize.
          </p>
          <p className="rounded-2xl bg-mist p-5 text-ink" data-id="element-299" data-mp="3eyiqtqitsbfx">
            My goal isn’t to replace your clinical judgment or turn complex motor behaviors into automatic classifications.
            It’s to help you <strong data-id="element-300" data-mp="bhtiq03lgto5">organize the information you already have</strong> and recognize what deserves further
            investigation.
          </p>
        </div>
        <SectionCta label="Yes, I want to organize my cases" data-id="element-301" data-mp="1qyu4p2vlhzj" />
      </div>
    </section>;
}